import { useContext } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../store/auth-context';

const Footer = () => {
  const context = useContext(AuthContext);

  const navigate = useNavigate();

  const isAdminHandler = () => {
    context.isLoggedIn && context.pathname === '/admin' && navigate('/');
    context.isLoggedIn && context.pathname !== '/admin' && navigate('/admin');

    !context.isLoggedIn && context.pathname === '/login' && navigate('/');
    !context.isLoggedIn && context.pathname !== '/login' && navigate('/login');
  };

  const logout = () => {
    localStorage.clear();
    context.logoutHandler(false);
  };

  useEffect(() => {}, [context.isLoggedIn]);

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });

  return (
    <footer>
      <div id='admin'>
        <button className='uppercase admin-btn' onClick={isAdminHandler}>
          {/* {pathname === '/login'
            ? 'Back'
            : !isLoggedIn
            ? 'Admin Login'
            : 'Back'} */}
          {(context.isLoggedIn && context.pathname === '/admin') ||
          (context.isLoggedIn && context.pathname !== '/admin') ||
          (!context.isLoggedIn && context.pathname === '/login')
            ? 'Back'
            : !context.isLoggedIn &&
              context.pathname !== '/login' &&
              'Admin Login'}
        </button>

        {context.isLoggedIn && (
          <>
            <button className='uppercase admin-btn me-3' onClick={logout}>
              Logout
            </button>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;
